/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import Text from "./Text";

const StyledStatusRibbon = styled.div`
  position: absolute;
  top: 32px;
  right: 0;
  max-width: 360px;
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem 0 0 0.5rem;
  border: 1px solid;
  border-right: none;
  text-align: center;

  ${({ $tone }) => toneStyles[$tone]}

  ${({ theme }) => theme.containerMedia.md} {
    width: auto;
  }
`;

const toneStyles = {
  accent: css`
    color: rgba(${({ theme }) => theme.colors.accent.rgba});
    border-color: rgba(${({ theme }) => theme.colors.accent.rgba});
    background-color: rgba(${({ theme }) => theme.colors.accent.rgb}, 0.1);
  `,
  accentFilled: css`
    color: rgba(${({ theme }) => theme.colors.accentContrast.rgba});
    border-color: rgba(${({ theme }) => theme.colors.accent.rgba});
    background-color: rgba(${({ theme }) => theme.colors.accent.rgba});
  `,
  neutral: css`
    color: rgba(${({ theme }) => theme.colors.textSecondary.rgba});
    border-color: rgba(${({ theme }) => theme.colors.textSecondary.rgba});
    background-color: rgba(${({ theme }) => theme.colors.textSecondary.rgb}, 0.1);
  `,
  success: css`
    color: rgba(${({ theme }) => theme.colors.success.rgba});
    border-color: rgba(${({ theme }) => theme.colors.success.rgba});
    background-color: rgba(${({ theme }) => theme.colors.success.rgb}, 0.1);
  `,
  warning: css`
    color: rgba(${({ theme }) => theme.colors.warning.rgba});
    border-color: rgba(${({ theme }) => theme.colors.warning.rgba});
    background-color: rgba(${({ theme }) => theme.colors.warning.rgb}, 0.1);
  `,
  error: css`
    color: rgba(${({ theme }) => theme.colors.error.rgba});
    border-color: rgba(${({ theme }) => theme.colors.error.rgba});
    background-color: rgba(${({ theme }) => theme.colors.error.rgb}, 0.1);
  `,
};
const toneTextColor = {
  accent: "accent",
  accentFilled: "accentContrast",
  neutral: "default",
  success: "success",
  warning: "warning",
  error: "error",
};

const StatusRibbon = ({ tone = "neutral", title }) => {
  return (
    <StyledStatusRibbon $tone={tone}>
      <Text color={toneTextColor[tone]}>
        {title}
      </Text>
    </StyledStatusRibbon>
  );
};

export default StatusRibbon;
